import { useEffect, useRef } from 'react';
import { UserMessage } from './UserMessage';
import { AssistantMessage } from './AssistantMessage';
import { TypingIndicator } from './TypingIndicator';
import type { Message } from '../components/ChatSheet';
import styles from './MessageList.module.css';

interface MessageListProps {
  messages: Message[];
  isTyping: boolean;
  welcomeText: string;
}

export function MessageList({ messages, isTyping, welcomeText }: MessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  return (
    <div className={styles.messages} role="log" aria-live="polite" aria-label="Chat messages">
      <div className={styles.welcome}>
        <AssistantMessage text={welcomeText} />
      </div>

      {messages.map((message) =>
        message.role === 'user' ? (
          <UserMessage key={message.id} text={message.text} />
        ) : (
          <AssistantMessage key={message.id} text={message.text} />
        )
      )}

      {isTyping && <TypingIndicator />}
      <div ref={bottomRef} />
    </div>
  );
}
